import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from './click-outside/click-outside.directive';
import { SparkPasteDigitsOnlyDirective } from './paste-digits-only/paste-digits-only.directive';

@NgModule({
  declarations: [ClickOutsideDirective, SparkPasteDigitsOnlyDirective],
  imports: [CommonModule],
  exports: [ClickOutsideDirective, SparkPasteDigitsOnlyDirective]
})
export class SparkPlusDirectiveModule {}
